import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import Tabs from '../../components/tabs';
import CampaignsList from '../campaign-list';
import InfluencersCampaignsList from '../influencers-campaign-list';
import { ARCHIVED, ACTIVE } from '../../utils/static-configuration';
import { updateShowCampaignsList } from '../../containers/influencers-campaign-list/actions';
import { setStatusBar, clearStatusBar } from '../../containers/status-bar/actions';
import StatusBar from '../../containers/status-bar';
import hasUserInfo from '../../hocs/has-user-info';
import ThemeSelector from '../../themes/theme-selector';


class Dashboard extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  changeUrlPath = path => this.context.router.push(path);


  componentWillUnmount() {
    this.props.onClearStatusBar();
  }

  updateShowCampaignList = showCampaignList => event => {
    event.preventDefault();
    this.props.onUpdateShowCampaignsList(showCampaignList);
  };

  render() {
    const { campaignsList, showCampaignsList, viewedOnboarding } = this.props;
    const hideTabs = !(campaignsList.size > 0);
    const tabsStyle = !hideTabs ? 'white border-bottom' : '';
    const panes = [ACTIVE, ARCHIVED];
    const { userInfo: { role } } = this.props;

    const theme = ThemeSelector.theme();
    const hideCampaigns = theme.hideHomepage || false;

    const isInfluencer = role === 'INFLUENCER';

    return (
      <div className="page">
        <StatusBar />
        {
          !hideCampaigns &&
          <Tabs
            title="My Campaigns"
            headerStyle={`padded-content ${tabsStyle}`}
            tabsStyle={'tabs'}
            hideTabs
            active={showCampaignsList}
            onClick={this.updateShowCampaignList}
          />
        }
        <div className="page-content">
          {
            isInfluencer &&
            <InfluencersCampaignsList active={showCampaignsList} />
          }
          {
            !isInfluencer &&
            <CampaignsList active={showCampaignsList} />
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  campaignsList: state.campaignList.get('campaigns'),
  showCampaignsList: state.campaignList.get('showCampaignsList'),
  viewedOnboarding: state.userOnboarding.get('viewedOnboarding'),
});

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onUpdateShowCampaignsList: campaignStatus => dispatch(updateShowCampaignsList(campaignStatus)),
    onSetStatusBar: (message, colour) => dispatch(setStatusBar(message, colour)),
    onClearStatusBar: () => dispatch(clearStatusBar()),
  };
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  hasUserInfo,
)(Dashboard);



/** WEBPACK FOOTER **
 ** ./src/containers/dashboard/index.js
 **/